var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#002D72;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M545.3,405.7h-49.8c-0.9-6.4-2.8-12.2-5.6-17.2c-2.8-5-6.4-9.3-10.8-12.9c-4.4-3.6-9.5-6.3-15.2-8.2 c-5.7-1.9-11.9-2.8-18.6-2.8c-12,0-22.5,3-31.5,8.9c-8.9,5.9-15.9,14.6-20.8,25.9c-4.9,11.3-7.4,25.1-7.4,41.2 c0,16.6,2.5,30.5,7.4,41.8c5,11.3,11.9,19.8,20.9,25.6c8.9,5.8,19.3,8.6,31,8.6c6.6,0,12.7-0.9,18.4-2.6 c5.6-1.7,10.7-4.3,15.1-7.7c4.4-3.4,8-7.5,11-12.3c2.9-4.8,4.9-10.4,6.1-16.6l49.8,0.2c-1.3,10.7-4.5,21-9.6,30.9 c-5.1,9.9-12,18.7-20.6,26.5c-8.6,7.8-18.8,13.9-30.7,18.4c-11.9,4.5-25.2,6.8-40.2,6.8c-20.8,0-39.3-4.7-55.6-14.1 c-16.3-9.4-29.2-23-38.6-40.8c-9.4-17.8-14.1-39.4-14.1-64.7c0-25.4,4.8-47,14.3-64.8c9.5-17.8,22.5-31.4,38.9-40.7 c16.4-9.4,34.8-14,55.2-14c13.5,0,26,1.9,37.6,5.7c11.6,3.8,21.8,9.3,30.7,16.5c8.9,7.2,16.2,16.1,21.9,26.5 C540.1,380.3,543.7,392.2,545.3,405.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCIcon);
export default __webpack_public_path__ + "static/media/c_icon.212602a305a641d677eb42665c20b631.svg";
export { ForwardRef as ReactComponent };